import { NestedListRenderer } from 'src/common/editorjs/NestedListRenderer';

export const editorjsRenderers = {
  list: NestedListRenderer,
};
